<mat-radio-group class="smart-data-type-radios"
                 [formControl]="control">
  <mat-radio-button [value]="data_type_opt"
                    *ngFor="let data_type_opt of data_type_opts">
    {{ 'alerts.smart_alerts.smart_digest.configuration.data_type_opts.' + data_type_opt | translate }}
  </mat-radio-button>
</mat-radio-group>
